import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import { NGXLogger } from "ngx-logger";
import { Api } from "src/app/shared/constants/api";
import { KEYS } from "src/app/shared/constants/keys";
import { DataService } from "src/app/shared/services/data.service";
import { storageService } from "src/app/shared/services/Storage.Service";
import { IdleService } from "src/app/shared/services/idle.service";
import * as _ from 'underscore';

@Component({
    selector: "app-company-branch",
    templateUrl: "./company-branch.component.html",
    styleUrls: ["./company-branch.component.less"],
    standalone: false
})
export class CompanyBranchComponent implements OnInit {
  companys = [];
  companyBranches = [];
  selectedCompany = [];
  companyBranchForm:FormGroup;

  constructor(
    private router: Router,
    private service: DataService,
    private logger: NGXLogger,
    private formBuilder:FormBuilder,
    private storage: storageService,
    private idleService: IdleService
  ) {}

  ngOnInit(): void {
    this.getCompanys();
    this.initializeForm();
  }

  initializeForm(){
     this.companyBranchForm=this.formBuilder.group({
       companyName:[null,[Validators.required]],
       branchId:[]
     });
  }

  async onSubmit() {
    this.companyBranchForm.markAllAsTouched();
    if(!this.companyBranchForm.valid)
         return;
    sessionStorage.setItem("Role", "User");
    this.getUserSpecificPermissions();
    this.router.navigate(["/dashboard"]);
  }

  getCompanys() {
    this.service.get(Api.USER_COMPANY_LIST).subscribe((res) => {
      this.logger.info("company list res", res);
      if(res){
        this.companys = res;
      }
    });
  }

  getBranchesByCompanyId(companyName) {
    this.companyBranches=[];
    this.logger.info('company event value',companyName);
    let company=_.findWhere(this.companys,{name:companyName});
    this.storage.setCompanyId(company.companyId.toString());
    localStorage.setItem(KEYS.CLIENT_ID, company.clientId.toString());
    this.service.get(Api.USER_COMPANY_BRANCH_LIST+company?.companyId).subscribe((res) => {
      this.logger.info("company Branch res", res);
      if(res){
        this.companyBranches=res;
      }
    });
  }

  branchChanged(branchId: number) {
    this.logger.info("branch id : ", branchId);
    localStorage.setItem(KEYS.BRANCH_ID, branchId.toString());
  }

  public loginInWithDifferentUser(){
    this.idleService.stop();
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(["/login"]);
  }

  getUserSpecificPermissions(){
    let data ={clientId:+localStorage.getItem(KEYS.CLIENT_ID),
               companyId:+localStorage.getItem(KEYS.COMPANY_ID),
              branchId:+localStorage.getItem(KEYS.BRANCH_ID)};
    this.service.get(Api.COMPANY_SPECIFIC_AUTHORITY,data).subscribe(res => {
      this.logger.info('Company Spcecific Authority',res);
      if(res.permission){
        localStorage.setItem(KEYS.PERMISSION_DATA,JSON.stringify(res.permission));
      }
    });
  }

  get companyName(){return this.companyBranchForm.get('companyName') };
}
